<template>
    <modal-dialog
        ref="modalDialog"
        confirmBtnTxt="Save"
        :isLoading="isLoading"
        @confirm-dialog="addPaymentMethod"
        @close="() => this.$emit('close')"
    >
        <template v-slot:title>
            <div class="d-flex align-items-center">
                <i class="cus-lock" /> New Payment Card
            </div>
        </template>
        <template v-slot:body>
            <div>
                <div class="form-row form-group">
                    <div class="col-4 col-form-label">
                        <label id="card_number">Name On Card:</label>
                    </div>

                    <div class="bv-no-focus-ring col">
                        <div class="h-100 d-flex align-items-center">
                            <input
                                class="form-control w-100"
                                placeholder="Name on Card"
                                v-model="nameOnCard"
                                v-validate="'required'"
                                name="name_on_card"
                                :class="{
                                    'border-danger': errors.has('name_on_card')
                                }"
                                autofocus
                            />
                        </div>
                    </div>
                </div>

                <div
                    v-show="isIframeLoaded"
                    class="form-row form-group iframe-form"
                >
                    <div class="col-4 col-form-label">
                        <label id="card_number">Card Number:</label>
                        <label id="expiration">Expiration:</label>
                        <label id="scode">Security Code </label>
                        <a href="#" @click.prevent>
                            <i
                                v-b-popover.hover.bottom="
                                    'For Visa, MasterCard, and Discover, the security code is the last 3 digit number located on the back of the card or above the signature line. For American Express, it is the 4 digits on the front of the card above the end of the card number.'
                                "
                                class="cus-information"
                                container="app"
                                title="Note"
                            ></i></a
                        >:
                    </div>

                    <div class="bv-no-focus-ring col">
                        <div
                            class="h-100 d-flex align-items-center iframe_content"
                            id="iframe_content"
                        >
                            <iframe
                                v-if="cardConnectUrl"
                                id="tokenframe_p"
                                name="tokenframe"
                                :src="cardConnectUrl"
                                frameborder="0"
                                scrolling="no"
                                @load="$emit('iframe-loaded')"
                            ></iframe>
                        </div>
                    </div>
                </div>

                <div class="form-row form-group">
                    <div class="col-4 col-form-label">
                        <label id="card_number">Primary:</label>
                    </div>

                    <div class="bv-no-focus-ring col">
                        <div class="h-100 d-flex align-items-center">
                            <b-select
                                :options="['Yes', 'No']"
                                name="date"
                                value="Yes"
                                disabled
                            ></b-select>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </modal-dialog>
</template>
<script>
import ModalDialog from "@/components/commons/modal-dialog";
import subscriptionService from "@/services/subscription";

export default {
    components: {
        ModalDialog
    },
    data() {
        return {
            isLoading: false,
            isIframeLoaded: false,
            paymentMethod: null,
            nameOnCard: "",
            cardToken: {
                message: null,
                expiry: null,
                validationError: null
            },
            cardConnectUrl: ""
        };
    },
    async created() {},
    methods: {
        async open(paymentMethod) {
            this.$emit("updateIsLoadingAddModal", true);
            this.$validator.reset();

            this.cardConnectUrl = "";
            this.nameOnCard = "";
            this.isLoading = false;
            this.isIframeLoaded = false;
            this.paymentMethod = paymentMethod;

            await this.getCardConnectIframeUrl();
            this.cardConnectListener();
        },

        async addPaymentMethod() {
            if (this.isLoading) return;
            this.isLoading = true;

            let valid = await this.$validator.validateAll();

            if (!valid) {
                this.isLoading = false;
                return;
            }

            setTimeout(async () => {
                if (this.cardToken.validationError) {
                    this._message(
                        `Error: Invalid card information. Please ensure all details are correct.`,
                        "danger"
                    );
                    this.isLoading = false;
                    return;
                }

                if (!this.cardToken.message) {
                    this._message(
                        `Error: Invalid card information. Please ensure all details are correct.`,
                        "danger"
                    );
                    this.isLoading = false;
                    return;
                }

                if (!this.cardToken.expiry) {
                    this._message(
                        `Error: Invalid card information. Please ensure all details are correct.`,
                        "danger"
                    );
                    this.isLoading = false;
                    return;
                }

                try {
                    const response = await subscriptionService.createPaymentMethod(
                        {
                            name: this.nameOnCard,
                            isPrimary: 1,
                            cardNumber: this.cardToken.message,
                            expiration: this.cardToken.expiry
                        }
                    );

                    const { message } = response;
                    if (message && message.code == 200) {
                        this.$emit("getPaymentMethods", 1);
                        this.paymentMethod = null;
                        this._message(
                            "Payment method successfully created.",
                            "success"
                        );

                        this.$refs.modalDialog.close();
                    } else {
                        this._message(
                            `Error: Cannot Create Payment Method`,
                            "danger"
                        );
                        this.isLoading = false;
                    }
                } catch (error) {
                    this.isLoading = false;
                    this._message(`Error : ${error.message}`, "danger");
                }
            }, 4000);
        },

        cardConnectListener() {
            setTimeout(() => {
                this.isIframeLoaded = true;
            }, 350);
            this.$once("iframe-loaded", () => {
                setTimeout(() => {
                    this.$emit("loaded");
                    let self = this;

                    window.addEventListener(
                        "message",
                        function (event) {
                            const token = JSON.parse(event.data);

                            if (
                                typeof token.message !== "undefined" &&
                                typeof token.expiry !== "undefined"
                            ) {
                                self.cardToken.message = token.message;
                                self.cardToken.expiry = token.expiry;
                                self.cardToken.validationError = null;
                            } else {
                                if (
                                    typeof token.validationError !== "undefined"
                                ) {
                                    self.cardToken.validationError =
                                        token.validationError;
                                }
                            }
                        },
                        false
                    );
                }, 350);
            });
        },

        async getCardConnectIframeUrl() {
            const data = await this._getSubscriptionConfig();
            if (data && data.cardconnect_iframe_url) {
                this.cardConnectUrl = data.cardconnect_iframe_url;
            }
        }
    },
    watch: {
        isIframeLoaded(value) {
            if (value) {
                this.$refs.modalDialog.open();
                this.$emit("updateIsLoadingAddModal", false);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.iframe-form .bv-no-focus-ring {
    padding: 2px !important;
}

.cus-information {
    margin-top: 1px !important;
    margin-right: 0px !important;
    margin-left: 1px !important;
}

.iframe_content {
    width: 100% !important;
    float: right;
}

iframe#tokenframe_p {
    width: 125% !important;
    height: 109px;
    margin-top: -6px;
    margin-left: -0.25rem;
}

.col-4 {
    -webkit-box-flex: 0 !important;
    -ms-flex: 0 0 33.33333% !important;
    flex: 0 0 26.1% !important;
    max-width: 33.33333% !important;
}
</style>
